<template>
  <div class="part-unregister tb" v-if="funcView.part_unregister_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 导出 -->
        <el-form-item v-if="funcView.part_unregister_export" style="float: right; margin-right: 0">
          <el-button class="table-set" style="vertical-align: top;" @click="exportTable('partUnregisterExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right;" :class="{'mr-0': !funcView.part_unregister_export}">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            :placeholder="$t('asm_part_unregister.jshljbhgd')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        ref="tb1"
        :data="tableList"
        :column="tableColumn"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['action']"
        height="100%"
      >
       <template slot="action" slot-scope="scope">
         <span></span>
         <!-- handleState 0待处理 标记无效-->
          <el-button type="text" size="mini" @click="invalidEvent(scope.row)" v-if="funcView.part_unregister_mark_invalid && scope.row.handleState===0">{{funcView.part_unregister_mark_invalid}}</el-button>
          <el-button type="text" size="mini" @click="addCaseEvent(scope.row)" v-if="funcView.part_unregister_add_case &&scope.row.handleState===0">{{ $t('asm_part_unregister.tian_jia_an_li') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!-- <add-workorder-dialog
      v-if="dialogVisible"
      :data="dialogData"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="onCurrentPage(1)"
    ></add-workorder-dialog> -->
    <add-case-dialog
      v-if="dialogVisible"
      @close="dialogVisible = false"
      :model="dialogModel"
      @success="onPageChange({ page: 1 })"
    ></add-case-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
// import addWorkorderDialog from '../offlineStatistics/children/add_workorder_dialog.vue';
import addCaseDialog from '@/pages/asm/components/add_case_dialog';

export default {
  name: 'partUnregister',
  components: { addCaseDialog },
  data() {
    return {
      tableCode: 'part_unregister',
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        unregisterState: '',
        pageSize: 20,
        pageNum: 1
      },

      selectedRow: {},
      dataTimes: null,
      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {}
    };
  },
  mounted: function () {
    this.getTableColumn();
    this.getTableList();
    this.getFuncView();
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.partUnregisterPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 标记无效
    invalidEvent: function (row) {
      const tpl = this.$t('asm_part_unregister.nqdyjsxdljbjwwxm');
      this.$showConfirm(tpl)
        .then(() => {
          this.$postJSON(`${apis.partUnregisterInvalidTag}/${row.partUnregisterId}`).then(() => {
            this.$message({
              message: this.i18n.com_delete_success,
              type: 'success'
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 添加案例
    addCaseEvent: function (row) {
      this.dialogModel = {
        title: this.$t('asm_part_unregister.tian_jia_an_li'),
        data: row,
        createMode: '10', // 零件更换
        type: 'checkbox'
      };
      this.dialogVisible = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  }
};
</script>

<style lang='scss'>
@import "@/style/colors.scss";
.part-unregister {
}
</style>
